import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'

// Log git version info
console.log(
  '%c🚀 QuickMeet',
  'color: #06c; font-size: 20px; font-weight: bold;'
);
console.log(
  `%cGit Hash: %c${__GIT_HASH_SHORT__}`,
  'color: #8e8e93; font-weight: bold;',
  'color: #06c; font-family: monospace;'
);
console.log(
  `%cFull Hash: %c${__GIT_HASH__}`,
  'color: #8e8e93; font-weight: bold;',
  'color: #06c; font-family: monospace;'
);
console.log(
  '%cView on GitHub: https://github.com/TheJhyeFactor/quickmeet',
  'color: #8e8e93;'
);
console.log(
  '%cDeployed: 2025-12-26 10:06 UTC',
  'color: #8e8e93; font-size: 10px;'
);

// Hide initial splash once React is ready
const hideSplash = () => {
  const splash = document.getElementById('initial-splash');
  if (splash) {
    splash.classList.add('fade-out');
    setTimeout(() => splash.remove(), 300);
  }
};

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

// Hide splash after a brief delay to ensure React has mounted
setTimeout(hideSplash, 100);
